import type { FC } from 'react';
import type React from 'react';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { PiGear } from 'react-icons/pi';
import { Link } from 'react-router-dom';
import ContactsOutlinedIcon from '@mui/icons-material/ContactsOutlined';
import { Box, Button, Popover, Typography } from '@mui/material';

import { routePaths } from 'src/services/routing/routePaths';
import { useUserContext } from 'src/components/app/context/UserContext';

import { styles } from './index.styles';

const SettingsMenu: FC = () => {
  const { t } = useTranslation('survey');
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const { user, currentSurvey } = useUserContext();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = useMemo(() => Boolean(anchorEl), [anchorEl]);

  const showMenu = useMemo(
    () => currentSurvey && user && user.role?.canEditSurveySettings,
    [currentSurvey, user],
  );

  if (!showMenu) {
    return null;
  }

  return (
    <>
      <Button sx={styles.button} onClick={handleClick} endIcon={<PiGear />}>
        <Typography variant="body3" sx={{ fontWeight: 600 }}>
          {t('settings.menuButton')}
        </Typography>
      </Button>
      <Popover
        open={open}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        slotProps={{ paper: { sx: styles.popover } }}
      >
        <Box
          sx={styles.menuItem}
          component={Link}
          to={routePaths.SURVEY_SETTINGS}
        >
          <PiGear fontSize="small" />{' '}
          <Typography variant="button2" color="inherit">
            {t('settings.surveySettings')}
          </Typography>
        </Box>
        <Box
          sx={styles.menuItem}
          component={Link}
          to={routePaths.USER_ADMIN_LIST}
        >
          <ContactsOutlinedIcon />
          <Typography variant="button2" color="inherit">
            {t('settings.userAdministration')}
          </Typography>
        </Box>
      </Popover>
    </>
  );
};
export default SettingsMenu;
